/*
 * Checkout payment types, matching the ids in Collaterate's PaymentType static entity map.
 *
 * SAVED_CREDIT_CARD is deliberately omitted. It is a valid PaymentType server-side, but the v2 REST
 * checkout excludes it from both card gates (ProjectV2Provider#updatePaymentInfo and #order), so a
 * project patched with it stores no payment token, skips authorization entirely, and produces an
 * unpaid order that still reports as prepaid downstream. Use CREDIT_CARD with a savedPaymentMethodToken
 * for saved cards, and PAYPAL with a savedPaymentMethodToken for vaulted PayPal accounts.
 */

export default Object.freeze({
    CREDIT_CARD: 'CREDIT_CARD',
    PAYPAL: 'PAYPAL',
    TERMS: 'TERMS',
});
